import { useCallback } from "react";

/**
 * Arrow-key navigation for a selectable list: ↑/↓ move between rows, Enter/Space toggles, Escape closes the open row.
 * Rows are plain DOM nodes with `data-row-id`; the caller keeps the open state. With `follow`, moving while a row is
 * open selects the next row too – the inspector browses live.
 */
export function useRowNav(open, setOpen, { follow = false } = {}) {
  return useCallback((e, id) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen((v) => (v === id ? null : id)); return; }
    if (e.key === "Escape" && open) { e.preventDefault(); setOpen(null); return; }
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    const rows = Array.from(e.currentTarget.closest("[data-rownav]")?.querySelectorAll("[data-row-id]") || []);
    const i = rows.indexOf(e.currentTarget);
    const next = rows[e.key === "ArrowDown" ? i + 1 : i - 1];
    if (!next) return;
    next.focus();
    if (follow && open) setOpen(next.dataset.rowId);
  }, [open, setOpen, follow]);
}
